import langConfig from '#/config/language/langConfig';

const poeditorConfig = {
  token: '4f54c5596daaee53e2967303c2b52cf3',
  projectId: 554781,
  languages: Object.keys(langConfig.items || { en: '' }),
  additionalProjects: [], // TODO maybe later add additional project
};

export interface PoeditorConfig {
  token: string,
  projectId: number,
  languages: Array<string>,
  additionalProjects?: Array<number>,
}

export default poeditorConfig;
